import Axios, { AxiosRequestConfig, AxiosResponse } from 'axios';

type Request = AxiosRequestConfig & { id: number };
type Response = AxiosResponse & { config: Request };

const createAxiosInstance = () => {
  const axios = Axios.create();

  return axios;
};

const stringifyRequestHead = (request: Request) => {
  const { id, url, method, data } = request;

  return `#${id} ${(method || '').toUpperCase()}: ${url}`;
};

const stringifyRequest = (request: Request) => {
  const { id, url, method, data } = request;

  return [`Request ${stringifyRequestHead(request)}:\n---\n`, data, `\n---\n`];
};

const stringifyResponse = (response: Response) => {
  const { config, data, status } = response;

  return [`Response ${stringifyRequestHead(config)}:\n---\n${status}\n`, data, `\n---\n`];
};

export const axios = createAxiosInstance();
